import React from "react";
import { CustomFieldFilter } from "../../../../clients/graphqlTypes.js";
import { FilterChip } from "../../../commons/filters/FilterChip.js";
import { getExistingOperator, getHumanReadableOperator } from "../helpers.js";

interface Props {
  values: CustomFieldFilter[] | CustomFieldFilter | undefined | null;
  setValues?: (value: CustomFieldFilter[]) => void;
}

export const FilterCustomFieldsChips = ({ values, setValues }: Props) => {
  if (!values) return null;

  const chips = Array.isArray(values) ? values : [values];

  return (
    <>
      {chips.map((value, index) => {
        const operator = getExistingOperator(value);
        const humanReadableOperator = getHumanReadableOperator(operator);

        return (
          <FilterChip
            key={index}
            label={value.key}
            value={JSON.parse(value[operator])}
            onDelete={
              setValues
                ? () => setValues([...chips.filter(v => v.key !== value.key)])
                : undefined
            }
            divider={` ${humanReadableOperator} `}
          />
        );
      })}
    </>
  );
};
